import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

// components
import Navbar from "../components/Navbars/Navbar";
import Footer from "../components/Footer/Footer";
import Sidebar from "../components/Sidebar/Sidebar";

// helpers
import { getSessionCookie } from "../helpers/cookies";

// routes
import routes from "../routes.js";

var ps;

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: "black",
      activeColor: "info",
    };
    this.mainPanel = React.createRef();
  }
  componentDidMount() {
    this.validaPermissaoAcesso();      
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentWillUnmount() {        
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      this.mainPanel.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }  
  handleActiveClick = (color) => {
    this.setState({ activeColor: color });
  };
  handleBgClick = (color) => {
    this.setState({ backgroundColor: color });
  };

  validaPermissaoAcesso = () => {    
    let session = getSessionCookie();  
    if (session == null)
    {
      this.props.history.push('/auth/login');
      return;
    }   

    if (session.expired)
    {
      this.props.history.push('/auth/login');
      return;
    }   
    
    this.setState({routes: routes});

  }

  render() {
    return (
      <div>
        <div className="wrapper">
          {this.state.routes != null &&
            <Sidebar
              {...this.props}
              routes={this.state.routes}
              bgColor={this.state.backgroundColor}
              activeColor={this.state.activeColor}
            />
          }
          <div className="main-panel" ref={this.mainPanel}>
            <Navbar {...this.props} />
            <Switch>
              {this.state.routes != null && this.state.routes.map((prop, key) => {
                return (
                  <Route
                    path={prop.layout + prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer fluid />
          </div>
        </div>
    </div>
    );
  }
}

export default Admin;
